import { mode } from '@chakra-ui/theme-tools';
import type { ComponentStyleConfig } from '@chakra-ui/react';

/** Mensajes de error bajo inputs: coherente con toasts glass. */
export const FormErrorMessage: ComponentStyleConfig = {
  baseStyle: (props) => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: 2,
    borderRadius: '14px',
    px: 3,
    py: 2.5,
    mt: 2,
    fontSize: 'sm',
    fontWeight: '600',
    lineHeight: 'short',
    letterSpacing: '-0.01em',
    bg: mode(
      'linear-gradient(120deg, rgba(254,242,242,0.92) 0%, rgba(255,255,255,0.88) 100%)',
      'linear-gradient(120deg, rgba(127,29,29,0.42) 0%, rgba(27,37,75,0.45) 100%)'
    )(props),
    color: mode('red.700', 'red.100')(props),
    borderWidth: '1px',
    borderColor: mode('rgba(239, 68, 68, 0.35)', 'rgba(248, 113, 113, 0.35)')(props),
    backdropFilter: 'blur(14px) saturate(160%)',
    boxShadow: mode(
      '0 8px 28px rgba(239, 68, 68, 0.08), inset 0 1px 0 rgba(255,255,255,0.7)',
      '0 10px 32px rgba(0,0,0,0.25), inset 0 1px 0 rgba(255,255,255,0.08)'
    )(props),
    sx: {
      WebkitBackdropFilter: 'blur(14px) saturate(160%)',
    },
  }),
};
